import { render } from "./nuovoAppuntamentoModal.vue?vue&type=template&id=5de8cb9d&ts=true"
import script from "./nuovoAppuntamentoModal.vue?vue&type=script&lang=ts"
export * from "./nuovoAppuntamentoModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__